/**
 * 业务开关配置
 */

// 接口字段名称
export const FIELD_NAME_BUSINESS_SWITCH = "dynamic-business-switch";

// 业务开关配置本地存储键名
export const SYSTEM_CONFIG_BUSINESS_SWITCH_KEY = "SYSTEM_CONFIG_BUSINESS_SWITCH";

/**
 * 设置业务开关配置
 * @param value 业务开关配置
 */
export const setConfigBusinessSwitch = (value: any): void => {
  if (typeof localStorage === 'undefined') return;

  if (value == null) {
    localStorage.removeItem(SYSTEM_CONFIG_BUSINESS_SWITCH_KEY);
    return;
  }

  try {
    const str = JSON.stringify(value);
    localStorage.setItem(SYSTEM_CONFIG_BUSINESS_SWITCH_KEY, str);
  } catch (error) {
    console.error('Failed to set business switch config', error);
    // 可进一步降级处理或抛出
  }
};

/**
 * 获取业务开关配置
 * @returns 业务开关配置
 */
export const getConfigBusinessSwitch = <T = any>(): T | null => {
  if (typeof localStorage === 'undefined') return null;

  try {
    const raw = localStorage.getItem(SYSTEM_CONFIG_BUSINESS_SWITCH_KEY);
    if (raw === null) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null; // 解析失败统一返回 null，或根据业务决定
  }
};